import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import logger from '../../../services/logger';

import { UpdateCareerReadinessDTO } from './form-career-readiness.types';

export type CareerReadinessState = Partial<UpdateCareerReadinessDTO>;

const initialState: CareerReadinessState = {};

const careerReadinessSlice = createSlice({
  name: 'formCareerReadiness',
  initialState,
  reducers: {
    update: (state, action: PayloadAction<CareerReadinessState>) => {
      logger.debug('Updating career readiness state.', { state, action });
      Object.assign(state, { ...action.payload });
    },
  },
});

export const { update: updateCareerReadinessAction } = careerReadinessSlice.actions;
export default careerReadinessSlice.reducer;
